import { ScheduleDay } from './types';
import { WeeklyScheduleDao } from '../../../../models/Settings/WeeklySchedule';

export const DAY_API_MAP: Record<
  string,
  keyof Omit<WeeklyScheduleDao, 'holidays'>
> = {
  mon: 'monday',
  tue: 'tuesday',
  wed: 'wednesday',
  thu: 'thursday',
  fri: 'friday',
  sat: 'saturday',
  sun: 'sunday',
};

export const DEFAULT_SCHEDULE: ScheduleDay[] = [
  { day: 'mon', label: 'ПН', start: '09:00', end: '18:00' },
  { day: 'tue', label: 'ВТ', start: '09:00', end: '18:00' },
  { day: 'wed', label: 'СР', start: '09:00', end: '18:00' },
  { day: 'thu', label: 'ЧТ', start: '09:00', end: '18:00' },
  { day: 'fri', label: 'ПТ', start: '09:00', end: '18:00' },
  { day: 'sat', label: 'СБ', start: '09:00', end: '18:00' },
  { day: 'sun', label: 'ВС', start: null, end: null },
];
